import { Component, OnInit } from '@angular/core';
import {
  getTipoSistemaKey,
  TipoSistemaKey,
} from 'app/interfaces/enum/tipo-sistema';
import { ParametroHttpService } from '../parametro/parametro-http.service';
import { MessageService } from 'app/utils/toastr-custom/message.service';
import handleErrorMessage from 'app/utils/error-message-handler';
import { ParametroUtilsService } from 'app/utils/parametro-utils.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  tipoSistemas: TipoSistemaKey[] = [];

  isAgenciamentoCarga = false;
  isTransporteRodoviario = false;
  isSmxLogistics = false;
  carregandoTipoSistema = true;
  carregandoRazaoSocial = false;

  constructor(
    private parametroHttpService: ParametroHttpService,
    private messageService: MessageService,
    private _parametroUtilsService: ParametroUtilsService
  ) {}

  ngOnInit(): void {
    this.getTipoSistema();
  }

  validaEmpresaSmxLogistics(): void {
    this.carregandoRazaoSocial = true;
    this._parametroUtilsService.getParametroByNomeCarregado('PARAM_RAZAO_SOCIAL').subscribe(parametro => {
      const razaoSocial = parametro?.valor;
      this.isSmxLogistics =
        String(razaoSocial ?? '')
          .trim()
          .toUpperCase() === 'SMX LOGISTICS';
      this.carregandoRazaoSocial = false;
    });
  }

  private getTipoSistema(): void {
    this.carregandoTipoSistema = true;

    this.tipoSistemas = [];
    this.isAgenciamentoCarga = false;
    this.isTransporteRodoviario = false;

    this.parametroHttpService
      .getParametroByName('PARAM_TIPO_SISTEMA')
      .subscribe({
        next: parametro => {
          const valores = Array.isArray(parametro?.valor)
            ? parametro.valor
            : [parametro?.valor];

          this.tipoSistemas = valores
            .map(valor => getTipoSistemaKey(valor))
            .filter(
              (tipoSistema): tipoSistema is TipoSistemaKey =>
                tipoSistema !== null
            );
            console.log(this.tipoSistemas);

          this.isAgenciamentoCarga =
            this.tipoSistemas.includes('AGENCIAMENTO_CARGA');

          this.isTransporteRodoviario =
            !this.isAgenciamentoCarga &&
            this.tipoSistemas.includes('TRANSPORTE_RODOVIARIO');

          if (this.isAgenciamentoCarga) {
            this.validaEmpresaSmxLogistics();
          }

          this.carregandoTipoSistema = false;
        },
        error: error => {
          this.carregandoTipoSistema = false;

          handleErrorMessage(this.messageService, error);
        },
      });
  }
}
